import React from 'react';

import OAuthClient from 'intuit-oauth';

import { UiButton } from '../ui/ui-button';

import { ReactComponent as QuickbooksIcon } from './qb-icon.svg';

import { QUICKBOOKS } from '../config/quickbooks-config';

type InputProps = {
  org: Org;
  className?: string;
  variant?: 'primary' | 'secondary';
  size?: 'sm';
};

export const ConnectToQuickbooks = ({ org, className, variant, size }: InputProps) => {
  const handleClick = async () => {
    const oauthClient = new OAuthClient({
      clientId: QUICKBOOKS.CLIENT_ID,
      environment: QUICKBOOKS.ENVIRONMENT,
      redirectUri: QUICKBOOKS.REDIRECT_URI,
    });

    // IF (12/29/20): The state here are params we want to pass through the OAuth and receive when
    // the user lands back in Team Engine
    // xssSecurityToken: To prevent cross-site scripting attacks
    // redirect: The page the user initiated the integration from so we can bring them back there
    // orgId: Needed to create the integration record in the db
    const authUri = oauthClient.authorizeUri({
      scope: OAuthClient.scopes.Accounting,
      state: `xssSecurityToken=${QUICKBOOKS.XSS_SECURITY_TOKEN}&orgId=${org.org_id}&redirect=${window.location.pathname}`,
    });

    window.location.href = authUri;
  };

  const quickbooksStyle = org.QuickbooksIntegration ? '' : 'u-background-quickbooks u-color-white';

  return (
    <UiButton
      size={size}
      onClick={handleClick}
      variant={variant}
      disabled={Boolean(org.QuickbooksIntegration)}
      className={`${quickbooksStyle} ${className}`}
    >
      <QuickbooksIcon width={20} height={20} className="u-margin-right" />
      {org.QuickbooksIntegration ? 'Connected' : 'Connect'} To Quickbooks
    </UiButton>
  );
};
